if (!customElements.get('mega-rich')) {
  customElements.define(
    'mega-rich',
    class MegaRich extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[data-mega-rich-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-mega-rich-panel]'));
        if (this.tabs.length === 0) return;

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.activate(tab.dataset.megaRichTab));
          tab.addEventListener('keydown', (event) => this.onKeydown(event));
        });
      }

      activate(key) {
        this.tabs.forEach((tab) => {
          const active = tab.dataset.megaRichTab === key;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        this.panels.forEach((panel) => {
          panel.classList.toggle('is-active', panel.dataset.megaRichPanel === key);
        });
      }

      onKeydown(event) {
        const keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
        if (!keys.includes(event.key)) return;
        event.preventDefault();

        const current = this.tabs.findIndex((tab) => tab.classList.contains('is-active'));
        const last = this.tabs.length - 1;
        let next = current;

        if (event.key === 'ArrowLeft') next = current <= 0 ? last : current - 1;
        if (event.key === 'ArrowRight') next = current >= last ? 0 : current + 1;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = last;

        const target = this.tabs[next];
        if (!target) return;
        this.activate(target.dataset.megaRichTab);
        target.focus();
      }
    }
  );
}

function setMegaRichDrillOpen(open) {
  document.getElementById('menu_mobile')?.classList.toggle('mega-rich-drill-open', open);
}

document.addEventListener('click', (event) => {
  const opener = event.target.closest('[data-mega-rich-open]');
  if (opener) {
    const panel = document.getElementById(`mega-rich-mb-${opener.dataset.megaRichOpen}`);
    if (!panel) return;
    panel.hidden = false;
    setMegaRichDrillOpen(true);
    requestAnimationFrame(() => panel.classList.add('is-open'));
    opener.setAttribute('aria-expanded', 'true');
    return;
  }

  const closer = event.target.closest('[data-mega-rich-close]');
  if (!closer) return;
  const panel = closer.closest('[data-mega-rich-panel-mb]');
  if (!panel) return;
  panel.classList.remove('is-open');
  setMegaRichDrillOpen(false);
  const id = panel.id.replace('mega-rich-mb-', '');
  document.querySelector(`[data-mega-rich-open="${id}"]`)?.setAttribute('aria-expanded', 'false');
  setTimeout(() => {
    panel.hidden = true;
  }, 300);
});
